export default __webpack_public_path__ + "static/media/trash.e4e13bb9.svg";